import { useEffect, useState } from "react";
import { useDashboard } from "../../context/HDBDashboardContext.tsx";
import DashboardTabs from "./DashboardTabs";
import HDBDashboard from "../HDBDashboard";
import HdbSeekersListAdmin from "../HdbSeekersListAdmin/index.tsx";
import Dashboard from "../../assets/images/DashboardFill.svg";
import Registrations from "../../assets/images/Registrations.svg";
import ListView from "../../assets/images/registrationPrefill.svg";
import styles from "./index.module.scss";
import SeekerApproval from "../../components/SeatApprovalFlow/SeekerApproval/index.tsx";
import SeatApproval from "../../assets/images/outline-filled-seat.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { hasPermission } from "../../utils/roleBasedAccess.ts";
import { getItemInLocalStorage } from "../../services/localStorage.ts";
import { useResponsive } from "../../utils/functions.ts";
import UseResize from "../../common/components/UseResize/index.tsx";
import Drafts from "../Drafts/index.tsx";
import drafts from "../../assets/images/Drafts.svg";
import activeDraft from "../../assets/images/draftsSelected.svg";
import ReleaseSeats from "../../assets/images/Release Seats.svg";
import RegistrationsFill from "../../assets/images/Registration fill.svg";
import DashboardPrefill from "../../assets/images/dashboardPrefill.svg";

const DASHBOARD = "dashboard";
const REGISTRATIONS = "registrations";
const SEAT_ALLOCATIONS = "seat-allocations";
const DRAFTS = "drafts";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const { isMobileResolution, isTabResolution } = UseResize();
  const { clearFilters } = useDashboard();

  const [activeTab, setActiveTab] = useState(() => {
    // Default logic
    const storedTab = localStorage.getItem("hdb_active_tab");

    // Force SEAT_ALLOCATIONS tab if condition matches
    const seekerDetails = getItemInLocalStorage("seekerDetails");
    const role = seekerDetails?.role || "";

    const hasSeatPermission = hasPermission(role, "seat-allocations-tab", "R");
    if ((isMobileResolution || isTabResolution) && hasSeatPermission) {
      localStorage.setItem("hdb_active_tab", SEAT_ALLOCATIONS);
      return SEAT_ALLOCATIONS;
    }

    return storedTab || DASHBOARD;
  });

  const { filters } = useDashboard();
  const location = useLocation();
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";

  const hasSeatPermission = hasPermission(userRole, "seat-allocations-tab", "R");

  const tabs = [
    {
      label: "Dashboard",
      key: DASHBOARD,
      icon: (
        <img
          src={activeTab === DASHBOARD ? Dashboard : DashboardPrefill}
          alt="Dashboard"
          className={styles.subheaderIcons}
        />
      ),
    },
    ...(hasSeatPermission
      ? [
          {
            label: "Seat Allocations",
            key: SEAT_ALLOCATIONS,
            icon: (
              <img
                src={
                  activeTab === SEAT_ALLOCATIONS ? ReleaseSeats : SeatApproval
                }
                alt="seat allocations"
                className={styles.subheaderIcons}
              />
            ),
          },
        ]
      : []),
    {
      label: "Registrations",
      key: REGISTRATIONS,
      icon: (
        <img
          src={activeTab === REGISTRATIONS ? RegistrationsFill : ListView}
          alt="List view"
          className={styles.subheaderIcons}
        />
      ),
    },
    ...(hasPermission(userRole, "drafts-tab", "R")
      ? [
          {
            label: "Drafts",
            key: DRAFTS,
            icon: (
              <img
                src={activeTab === DRAFTS ? activeDraft : drafts}
                alt="Drafts"
                width={16.285}
                height={16.285}
              />
            ),
          },
        ]
      : []),
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
    clearFilters();
    localStorage.setItem("hdb_active_tab", key);
    
    if (key === SEAT_ALLOCATIONS || key === DASHBOARD) {
      const params = new URLSearchParams({
        dropdown: 'Unassigned',
        kpiCategory: 'unallocated',
        kpiFilter: 'total_unallocated',
        sidebarKey: 'total_unallocated'
      });
  
      navigate({
        pathname: location.pathname,
        search: params.toString()
      }, { replace: true });
    }
  };
  
  useEffect(() => {
    // Activate tab from navigation state if present
    if (location.state?.activateTab === "registrations") {
      setActiveTab(REGISTRATIONS);
    }
  }, [location.state]);

  useEffect(() => {
    if (filters && Object.keys(filters).length > 0) {
      setActiveTab(REGISTRATIONS);
      localStorage.setItem("hdb_active_tab", REGISTRATIONS);
    }
  }, [filters]);

  const shouldHideTabs = (isMobileResolution || isTabResolution) && hasSeatPermission;
  return (
    <div className={activeTab !== SEAT_ALLOCATIONS ? styles.dashboardLayout : ""}>
      {!shouldHideTabs && (
        <DashboardTabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      )}
      <div className={activeTab !== SEAT_ALLOCATIONS ? styles.contentArea : ""}>
        {activeTab === DASHBOARD && <HDBDashboard setActiveTab={setActiveTab} />}
        {activeTab === REGISTRATIONS && (
          <HdbSeekersListAdmin filters={filters} />
        )}
        {
          activeTab === SEAT_ALLOCATIONS && (
            <SeekerApproval />
          )
        }
           {activeTab === DRAFTS && (
          <Drafts/>
        )}                 
      </div>
    </div>
  );
};

export default DashboardLayout;